import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserTooltipRendererComponent } from './tooltip-renderer/browser-tooltip-renderer.component';
import { StringTemplateOutletModule } from '@shared/ui/kit/string-template-outlet/string-template-outlet.module';
import { IsTemplateRefModule } from '@shared/ui/tooltip/browser/tooltip-renderer/internal/is-template-ref.module';

@NgModule({
  declarations: [BrowserTooltipRendererComponent],
  imports: [CommonModule, StringTemplateOutletModule, IsTemplateRefModule]
})
export class BrowserTooltipModule {}
